<template>
  <div id="home-body">
    <b-row class="content-wrapper">
      <b-col sm="12">
        <h5>100원당 진세노사이드가 가장 많이 든 제품</h5>
        
      </b-col>
    </b-row>
  </div>
</template>

<script>
import util from '../util'
import {
  BRow, BCol,
  BIconCheck
} from 'bootstrap-vue'

export default {
  name: 'DashboardComponent',
  components: {
    BRow, BCol,
    BIconCheck
  },
  created() {

  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
#home-body {
  padding: 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue